import { Quote } from "lucide-react";

const masterclassTestimonials = [
  {
    id: "leslie",
    name: "Leslie",
    text: "Merci encore Loraine, j'emporte plein de beaux souvenirs de cette journée.",
    color: "#FFD6C9",
  },
  {
    id: "jessica",
    name: "Jessica",
    text: "Encore merci Loraine pour ce super stage ! J'aime beaucoup la manière dont tu mènes les choses, les exercices, tes explications. C'était vraiment chouette !",
    color: "#E6D7FF",
  },
  {
    id: "catherine",
    name: "Catherine",
    text: "Un stage ludique, créatif et évolutif pour s'exprimer et s'amuser dans nos rôles de femme ! Très belle expérience entre femmes bienveillantes. Le plaisir de retrouver toutes les facettes du féminin. À suivre !!!",
    color: "#C4F4E4",
  },
];

export const MasterclassSouvenir = () => (
  <section className="py-20 md:py-24 bg-[#FAFAFA]" data-testid="masterclass-souvenir">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="mb-12 max-w-3xl">
        <span className="font-sans text-sm font-bold tracking-[0.25em] uppercase text-[#8B5CF6]">
          Elles y étaient · 22 août
        </span>
        <h2 className="mt-3 font-display text-4xl md:text-6xl leading-none uppercase">
          Masterclass <br />
          <span className="italic">Rôles féminins</span> — le récap
        </h2>
        <p className="mt-4 text-base md:text-lg text-[#3a3a3a] max-w-xl">
          Retour sur cette journée intense à la Maison des Femmes d'Urrugne. Ce que les stagiaires en ont dit :
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {masterclassTestimonials.map((t, i) => (
          <article
            key={t.id}
            data-testid={`masterclass-testimonial-${t.id}`}
            className="relative border-2 border-black rounded-3xl p-6 shadow-brutal hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-brutal-sm transition-all"
            style={{
              backgroundColor: t.color,
              transform: `rotate(${(i - 1) * 0.75}deg)`,
            }}
          >
            <Quote size={28} className="text-[#0A0A0A]/70 mb-3" />
            <p className="font-sans text-[15px] leading-relaxed text-[#1a1a1a] italic">
              « {t.text} »
            </p>
            <p className="mt-5 font-display text-2xl uppercase tracking-wide">— {t.name}</p>
          </article>
        ))}
      </div>

      <div className="mt-10 text-center">
        <p className="font-sans text-sm text-[#3a3a3a]">
          Prochaine édition <strong>Rôles féminins</strong> · 12 décembre · Maison des Femmes · Urrugne
        </p>
      </div>
    </div>
  </section>
);
